<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
         ></BaseBreadcrumb>
         <update-profile-information-form :user="currentUser" />
         <update-password-form class="mt-10 sm:mt-0" />
         <div v-if="safeJetstream.canManageTwoFactorAuthentication">
            <two-factor-authentication-form class="mt-10 sm:mt-0" />
         </div>
         <logout-other-browser-sessions-form :vSessions="safeSessions" class="mt-10 sm:mt-0" />
         <!-- <delete-user-form class="mt-10 sm:mt-0" /> -->
      </v-container>
   </dashboard-layout>
</template>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import DeleteUserForm from './Profile/DeleteUserForm'
import JetSectionBorder from '@/Jetstream/SectionBorder'
import LogoutOtherBrowserSessionsForm from './Profile/LogoutOtherBrowserSessionsFormV'
import TwoFactorAuthenticationForm from './Profile/TwoFactorAuthenticationForm'
import UpdatePasswordForm from './Profile/UpdatePasswordForm'
import UpdateProfileInformationForm from './Profile/UpdateProfileInformationForm'
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'

export default {
   name: "MOMProfile",

   props: [ 'user', 'vSessions' ],

   components: {
      DashboardLayout,
      DeleteUserForm,
      JetSectionBorder,
      LogoutOtherBrowserSessionsForm,
      TwoFactorAuthenticationForm,
      UpdatePasswordForm,
      UpdateProfileInformationForm,
      BaseBreadcrumb
   },

   data() {
      return {
         page: {
         title: "Settings",
         },
         breadcrumbs: [
            {
               text: "Dashboard",
               disabled: false,
               to: "/dashboard",
            },
            {
               text: "Profile Settings",
               disabled: true,
            },
         ],
      }
   },

   methods: {
   },

   computed: {
      pageProps() {
         return (this.$page && (this.$page.props || this.$page)) || {}
      },

      safeJetstream() {
         return this.pageProps.jetstream || {}
      },

      currentUser() {
         return this.user || this.pageProps.user || {}
      },

      safeSessions() {
         if (Array.isArray(this.vSessions)) {
            return this.vSessions
         }

         return Array.isArray(this.pageProps.vSessions) ? this.pageProps.vSessions : []
      },
   },
}
</script>

